var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.redirectUrl
    ? _c(
        "div",
        {
          staticClass: "text-body-2 text-secondary--text text-center",
          attrs: { "data-qa": "redirect_timer_medtochka" },
        },
        [
          _vm._t("default", function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("МедТочка откроется через", _vm.options)) +
                  " "
              ),
              _c("span", { attrs: { id: "timer" } }),
              _vm._v(" " + _vm._s(_vm.$t("секунд", _vm.options)) + "\n  "),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }